import Api from "./Api";
import Csrf from "./Csrf";

export default { 
	
  async index() {
    await Csrf.getCookie();

    return Api.get("/guesthouses");
  },	
	
  async show(id) {
    await Csrf.getCookie();

    return Api.get("/guesthouses/"+id);
  },	
	
  async rooms(id) {
    await Csrf.getCookie();

    return Api.get("/guesthouses/"+id+"/rooms");
  },	
	
  async update(id,data) {
    await Csrf.getCookie();

    return Api.patch("/guesthouses/"+id,data);
  },	
};